import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";

const IMG = "/logo-full.png";

const reveal = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
};

const scrollTo = (href) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(href, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  }
};

export default function Partners() {
  const { t } = useLang();

  return (
    <section
      id="partnere"
      className="py-24 md:py-32 border-t border-[#2D2520]"
      data-testid="partners-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div
            {...reveal}
            transition={{ duration: 0.8 }}
            className="relative h-[420px] lg:h-[560px] rounded-xl border border-[#2D2520] overflow-hidden group bg-[#0D0B09] flex items-center justify-center"
            data-testid="first-partner-image"
          >
            <img
              src={IMG}
              alt="Bordverket"
              className="max-h-full max-w-full object-contain p-6 md:p-10 opacity-90 group-hover:scale-105 transition-transform duration-700"
            />
          </motion.div>

          <div>
            <motion.div {...reveal} transition={{ duration: 0.8, delay: 0.1 }}>
              <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#D48C46] mb-5">
                {t.partners.label}
              </p>
              <h2 className="font-serif font-medium text-4xl sm:text-5xl tracking-tight leading-tight text-[#F9F6F0]">
                {t.partners.joinTitle}
              </h2>
              <p className="mt-6 text-base md:text-lg leading-relaxed text-[#A69C95] max-w-md">
                {t.partners.joinBody}
              </p>
            </motion.div>

            <motion.div {...reveal} transition={{ duration: 0.8, delay: 0.3 }}>
              <button
                onClick={() => scrollTo("#kontakt")}
                data-testid="first-partner-cta-button"
                className="mt-10 inline-flex items-center rounded-sm bg-[#D48C46] px-8 py-4 text-sm font-semibold text-[#110E0C] hover:bg-[#F0A862] transition-colors duration-300"
              >
                {t.partners.joinCta}
              </button>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
